import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  root: { backgroundColor: '#AAAAAA00', flex: 0.4 },
  showDates: {
    paddingBottom: 5,
    paddingRight: 10,
  },
}));
